import {GridViewMetadata} from "../../../grid/gridView/types";
import {Column, ColumnKeys} from "./grid";

export * from './grid';
export * from './ringStagingVersionsResponse';
export * from './updateRings';
export interface CloudStagingListWebComponentSchema {
  viewMetaData: GridViewMetadata<Column, ColumnKeys>;

}
